import axios from "axios";
import { handlerError } from "../helpers";
import { DEFAULT_FIELD_CREATE } from "../constants/admin-fields";

const ROUTE_ADMIN = "/api/admin-settings";

const axiosPrivate = axios.create();

axiosPrivate.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    config.headers.common["Authorization"] = token ? `Token ${token}` : "";
    return config;
  },
  (error) => Promise.reject(error)
);


export const apiDeleteFrame = async (id) => {
  try {
    await axiosPrivate.delete(`${ROUTE_ADMIN}/${id}`);
  } catch (err) {
    handlerError(err)
  }
};

export const apiCreateFrame = async () => {
  try {
    await axiosPrivate.post(`${ROUTE_ADMIN}`, {
      settings: DEFAULT_FIELD_CREATE,
    });
  } catch (err) {
    handlerError(err)
  }
};

export const apiUpdateFrame = async (id, payload) => {
  try {
    await axiosPrivate.put(`${ROUTE_ADMIN}/${id}`, {
      settings: payload,
    });
  } catch (err) {
    handlerError(err)
  }
}

export const apiUpdateField = async (value, fieldName) => {
  console.log(value, fieldName)

  try {

    if(typeof fieldName !== 'string') {
      throw new Error('parameter "key" is required and type of string');
    }

    await axiosPrivate.post(`${ROUTE_ADMIN}/str/${fieldName}`,{
      value,
    })
  } catch (err) {
    console.log(err);
  }
}



// WEBPACK FOOTER //
// ./src/api/private.js